module.exports = __webpack_public_path__ + "img/logo-large.75d388f6.svg";